export const FETCH_TOKEN_SUCCESS = 'FETCH_TOKEN_SUCCESS';
export const DUMMY_ACTION_M = 'DUMMY_ACTION_M';
